<template>
  <div class="mox pt-5">
    <div
      class="col-md-8 col-lg-6 pl-0 pr-0 yuanjiao heggs lieb sjbdyuanjiao"
      style="margin: auto; max-height: 100vh; overflow-y: auto"
    >
      <div
        id="jnkwsedf"
        class="col-md-12 d-flex justify-content-center align-items-center pt-3 pb-3 pl-0 pr-0 xiaop"
        style="background: #ffffff; position: sticky; top: 0; z-index: 100"
      >
        <div class="d-flex align-items-center" style="cursor: pointer">
          <img
            class="mr-2"
            style="width: calc(46px + 0.4vw)"
            src="@/img/daohangl/pic_hssy_logo@2x.png"
            alt=""
          />
          <div style="font-size: calc(12px + 0.5vw); font-weight: 500">
            {{ $t("好事道") }}
          </div>
        </div>
      </div>
      <div class="baise position-relative">
        <div v-if="infodata.send_type != 0 && show == 0">
          <div
            v-if="infodata.image && isValidUrl(infodata.image)"
            class="sjbdkd"
            style="margin: auto; width: 100%"
          >
            <img
              class="sjbdtp"
              style="width: 100%"
              :src="infodata.image"
              alt=""
              @error="handleImageError"
            />
          </div>
          <div
            v-else
            class="sjbdkd text-center"
            style="width: 100%; margin: auto"
          >
            <img
              class="sjbdlogokd"
              style="width: 15%"
              :src="
                isValidUrl(infodata.organization_logo)
                  ? infodata.organization_logo
                  : 'https://gddao.com/logo.png'
              "
              alt=""
              @error="handleImageError"
            />
          </div>
        </div>
        <div class="pl-3 pr-3 pt-4 pb-3 question-container">
          <div
            class="mb-3 section-description pl-3 pr-3 pt-3 pb-3 col-md-10 col-lg-9"
            v-if="infodata.description && show == 0 && currentPage === 0"
            style="
              background: #f6f4f0;
              border-radius: 5px;
              margin: auto;
              font-size: calc(12px + 0.4vw);
            "
          >
            <div
              class="mb-2 sjbdzt"
              style="font-size: calc(14px + 0.4vw); font-weight: 600"
            >
              {{ infodata.name }}
            </div>
            <div class="questionnaire-description">
              <p
                v-for="(paragraph, paraIndex) in (infodata.description || '')
                  .split('\n')
                  .filter((p) => p.trim())"
                :key="paraIndex"
              >
                {{ paragraph }}
              </p>
            </div>
          </div>
          <div class="pl-0 pr-0 sjbdkd col-md-10 col-lg-9" style="margin: auto">
            <!-- 處理無內容的情況 -->
            <div v-if="!list || list.length === 0" class="text-center p-5">
              <div class="mb-3">
                <i
                  class="el-icon-warning"
                  style="font-size: 36px; color: #e6a23c"
                ></i>
              </div>
              <div class="mb-2 font-weight-bold">
                {{ $t("問卷內容載入中或無內容") }}
              </div>
              <div class="mb-3">
                {{ $t("請稍候或聯繫問卷發布者確認問卷是否正確設置") }}
              </div>
              <div>
                <button class="btn btn-warning" @click="formlist()">
                  {{ $t("重新載入") }}
                </button>
              </div>
            </div>

            <div v-else class="sjbzt" style="font-size: calc(9px + 0.4vw)">
              <!-- 顯示當前頁面的內容 -->
              <div
                v-if="
                  pages &&
                  pages.length > 0 &&
                  pages[currentPage] &&
                  pages[currentPage].length > 0
                "
              >
                <div>
                  <!-- 頁面標題和描述 -->
                  <div
                    class="text-center mt-4 mb-3 sjbzt"
                    v-if="currentPage === 0"
                    style="font-size: calc(10px + 0.4vw); font-weight: 500"
                  >
                    {{ list[0]?.part || "基本資料" }}
                  </div>

                  <!-- 頁面內容 -->
                  <div
                    class="mb-4"
                    v-for="(pageItem, pageItemIndex) in pages[currentPage]"
                    :key="pageItemIndex"
                  >
                    <!-- 處理區段標題與分隔類型 -->
                    <div
                      v-if="pageItem.item && pageItem.item.type == 'header'"
                      class="mb-4"
                    >
                      <!-- 如果是新頁面標記，顯示分隔線 -->
                      <div
                        v-if="pageItem.item && pageItem.item.isNewPage"
                        class="section-divider mt-4 mb-4"
                      >
                        <div class="divider-line"></div>
                        <div class="divider-line"></div>
                      </div>

                      <!-- 區段標題 -->
                      <h3
                        v-if="pageItem.item && pageItem.item.title"
                        class="section-header-title mb-3"
                      >
                        {{ pageItem.item.title }}
                      </h3>

                      <!-- 區段說明文字 -->
                      <div
                        v-if="pageItem.item && pageItem.item.description"
                        class="section-description mb-3 pl-3 pr-3 pt-3 pb-3"
                        style="
                          background: #f6f4f0;
                          border-radius: 5px;
                          font-size: calc(12px + 0.4vw);
                        "
                      >
                        <p
                          v-for="(paragraph, paraIndex) in (
                            pageItem.item.description || ''
                          )
                            .split('\n')
                            .filter((p) => p.trim())"
                          :key="paraIndex"
                        >
                          {{ paragraph }}
                        </p>
                      </div>
                    </div>

                    <div v-if="pageItem.item && pageItem.item.type == 'radio'">
                      <div
                        class="mb-2"
                        v-if="
                          form[pageItem.sectionIndex] &&
                          form[pageItem.sectionIndex][pageItem.itemIndex]
                        "
                      >
                        <span
                          v-if="pageItem.item.is_required"
                          style="color: #ff797a"
                          >*</span
                        >
                        {{
                          form[pageItem.sectionIndex][pageItem.itemIndex].index
                        }}.{{ pageItem.item.title
                        }}<span style="color: #ff797a">{{ $t("[單選]") }}</span>
                      </div>
                      <div
                        @click="
                          danxuan(
                            items.value,
                            pageItem.sectionIndex,
                            pageItem.itemIndex
                          )
                        "
                        v-for="(items, indexs) in pageItem.item.option"
                        :key="indexs"
                        class="d-flex justify-content-between align-items-center curpo pl-3 pr-3 pt-2 pb-2 mb-2"
                        :style="{
                          background:
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option == items.value
                              ? '#FFFAF0'
                              : '#F6F4F0',
                          border:
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option == items.value
                              ? '1px solid #FFD672'
                              : '',
                        }"
                        style="border-radius: 5px"
                      >
                        <div class="sjbxzt">{{ items.name }}</div>
                        <div
                          v-if="
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option == items.value
                          "
                        >
                          <img
                            style="width: 16px; height: 16px"
                            src="@/img/icon_dx_xz@1x.png"
                            alt=""
                          />
                        </div>
                        <div v-else>
                          <img
                            style="width: 16px; height: 16px"
                            src="@/img/icon_dx_wxz@1x.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="pageItem.item && pageItem.item.type == 'checkbox'"
                    >
                      <div
                        class="mb-2"
                        v-if="
                          form[pageItem.sectionIndex] &&
                          form[pageItem.sectionIndex][pageItem.itemIndex]
                        "
                      >
                        <span
                          v-if="pageItem.item.is_required"
                          style="color: #ff797a"
                          >*</span
                        >
                        {{
                          form[pageItem.sectionIndex][pageItem.itemIndex].index
                        }}.{{ pageItem.item.title
                        }}<span style="color: #ff797a">{{ $t("[多選]") }}</span>
                      </div>
                      <div
                        @click="
                          duoxuan(
                            items.value,
                            pageItem.sectionIndex,
                            pageItem.itemIndex
                          )
                        "
                        v-for="(items, indexs) in pageItem.item.option"
                        :key="indexs"
                        class="d-flex justify-content-between align-items-center curpo pl-3 pr-3 pt-2 pb-2 mb-2"
                        :style="{
                          background: form[pageItem.sectionIndex][
                            pageItem.itemIndex
                          ].option.includes(items.value)
                            ? '#FFFAF0'
                            : '#F6F4F0',
                          border: form[pageItem.sectionIndex][
                            pageItem.itemIndex
                          ].option.includes(items.value)
                            ? '1px solid #FFD672'
                            : '',
                        }"
                        style="border-radius: 5px"
                      >
                        <div class="sjbxzt">{{ items.name }}</div>
                        <div
                          v-if="
                            form[pageItem.sectionIndex][
                              pageItem.itemIndex
                            ].option.includes(items.value)
                          "
                        >
                          <img
                            style="width: 16px; height: 16px"
                            src="@/img/icon_ddx_xz@1x.png"
                            alt=""
                          />
                        </div>
                        <div v-else>
                          <img
                            style="width: 16px; height: 16px"
                            src="@/img/icon_ddx_wxz@1x.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="pageItem.item && pageItem.item.type == 'input'">
                      <div
                        class="mb-2"
                        v-if="
                          form[pageItem.sectionIndex] &&
                          form[pageItem.sectionIndex][pageItem.itemIndex]
                        "
                      >
                        <span
                          v-if="pageItem.item.is_required"
                          style="color: #ff797a"
                          >*</span
                        >
                        {{
                          form[pageItem.sectionIndex][pageItem.itemIndex].index
                        }}.{{ pageItem.item.title
                        }}<span style="color: #ff797a">{{ $t("[簡答]") }}</span>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center yuanjiao curpo"
                      >
                        <b-form-input
                          style="font-size: calc(8px + 0.5vw)"
                          v-model="
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option
                          "
                          type="text"
                          class="form-control srkddx yuanjiao sjbxzt"
                          :placeholder="$t('請輸入')"
                        >
                        </b-form-input>
                      </div>
                    </div>
                    <div
                      v-if="pageItem.item && pageItem.item.type == 'textarea'"
                    >
                      <div
                        class="mb-2"
                        v-if="
                          form[pageItem.sectionIndex] &&
                          form[pageItem.sectionIndex][pageItem.itemIndex]
                        "
                      >
                        <span
                          v-if="pageItem.item.is_required"
                          style="color: #ff797a"
                          >*</span
                        >
                        {{
                          form[pageItem.sectionIndex][pageItem.itemIndex].index
                        }}.{{ pageItem.item.title
                        }}<span style="color: #ff797a">{{ $t("[詳答]") }}</span>
                      </div>
                      <div
                        class="d-flex justify-content-between align-items-center yuanjiao curpo"
                      >
                        <b-form-textarea
                          class="form-control srkddx yuanjiao sjbxzt"
                          style="font-size: calc(8px + 0.5vw); height: 100px"
                          id="textarea"
                          v-model="
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option
                          "
                          :placeholder="$t('請輸入')"
                          rows="3"
                          max-rows="6"
                          no-resize
                        ></b-form-textarea>
                      </div>
                    </div>
                    <div v-if="pageItem.item && pageItem.item.type == 'score'">
                      <div
                        class="mb-2"
                        v-if="
                          form[pageItem.sectionIndex] &&
                          form[pageItem.sectionIndex][pageItem.itemIndex]
                        "
                      >
                        <span
                          v-if="pageItem.item.is_required"
                          style="color: #ff797a"
                          >*</span
                        >{{
                          form[pageItem.sectionIndex][pageItem.itemIndex].index
                        }}.{{ pageItem.item.title }}
                      </div>
                      <div class="d-flex yuanjiao srkddx pt-3 pl-3 yinc">
                        <div class="mr-3 sjbxzt sjbdmr">
                          {{ $t("評估分數") }}
                        </div>
                        <div
                          class="d-flex text-center sjdasxwd"
                          style="width: 76%; flex-wrap: wrap; margin: auto"
                        >
                          <div
                            class="curpo mr-3 mb-3 pjfs sjbxzt"
                            @click="
                              danxuan(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex
                              )
                            "
                            v-for="(items, indexs) in selScore"
                            :key="indexs"
                            :style="{
                              background:
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option == items.value
                                  ? '#FFD672'
                                  : '#F6F4F0',
                              border:
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option == items.value
                                  ? ''
                                  : '1px solid #b5b9c1',
                            }"
                          >
                            {{ items.name }}
                          </div>
                        </div>
                      </div>
                      <div class="yuanjiao srkddx pt-3 pl-3 pr-3 aaaaa">
                        <div class="mr-5 sjbxzt sjbdmr">
                          {{ $t("評估分數") }}
                        </div>
                        <div class="pt-2 pb-2">
                          <div
                            class="curpo mr-3 mb-3 pjfs sjbxzt d-flex text-center"
                            @click="
                              danxuan(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex
                              )
                            "
                            v-for="(items, indexs) in selScore"
                            :key="indexs"
                          >
                            <div class="mr-3" style="width: 15px">
                              {{ items.name }}
                            </div>
                            <div>
                              <img
                                v-if="
                                  form[pageItem.sectionIndex][
                                    pageItem.itemIndex
                                  ].option == items.value
                                "
                                src="@/img/icon_xuanzhong_quan@1x.png"
                                alt=""
                              />
                              <img
                                v-else
                                src="@/img/icon_weixuanzhong@1x.png"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="pageItem.item && pageItem.item.type == 'scale'">
                      <div
                        class="mb-2"
                        v-if="
                          form[pageItem.sectionIndex] &&
                          form[pageItem.sectionIndex][pageItem.itemIndex]
                        "
                      >
                        <span
                          v-if="pageItem.item.is_required"
                          style="color: #ff797a"
                          >*</span
                        >{{
                          form[pageItem.sectionIndex][pageItem.itemIndex].index
                        }}.{{ pageItem.item.title }}
                      </div>
                      <div class="d-flex yuanjiao srkddx pt-3 pl-3 pr-3 yinc">
                        <div class="mr-3 sjbxzt sjbdmr">
                          {{
                            pageItem.item.option && pageItem.item.option[0]
                              ? pageItem.item.option[0].name
                              : ""
                          }}
                        </div>
                        <div
                          class="d-flex text-center sjdasxwd"
                          style="width: 60%; flex-wrap: wrap; margin: auto"
                        >
                          <div
                            class="curpo mr-3 mb-3 pjfs sjbxzt"
                            @click="
                              danxuan(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex
                              )
                            "
                            v-for="(items, indexs) in selScore"
                            :key="indexs"
                            :style="{
                              background:
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option == items.value
                                  ? '#FFD672'
                                  : '#F6F4F0',
                              border:
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option == items.value
                                  ? ''
                                  : '1px solid #b5b9c1',
                            }"
                          >
                            {{ items.name }}
                          </div>
                        </div>
                        <div class="sjbxzt sjbdmr">
                          {{
                            pageItem.item.option && pageItem.item.option[1]
                              ? pageItem.item.option[1].name
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="yuanjiao srkddx pt-3 pl-3 pr-3 aaaaa pb-2">
                        <div class="mr-5 sjbxzt sjbdmr">
                          {{
                            pageItem.item.option && pageItem.item.option[0]
                              ? pageItem.item.option[0].name
                              : ""
                          }}
                        </div>
                        <div class="pt-2">
                          <div
                            class="curpo mr-3 mb-3 pjfs sjbxzt d-flex text-center"
                            @click="
                              danxuan(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex
                              )
                            "
                            v-for="(items, indexs) in selScore"
                            :key="indexs"
                          >
                            <div class="mr-3" style="width: 15px">
                              {{ items.name }}
                            </div>
                            <div>
                              <img
                                v-if="
                                  form[pageItem.sectionIndex][
                                    pageItem.itemIndex
                                  ].option == items.value
                                "
                                src="@/img/icon_xuanzhong_quan@1x.png"
                                alt=""
                              />
                              <img
                                v-else
                                src="@/img/icon_weixuanzhong@1x.png"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        <div class="sjbxzt sjbdmr">
                          {{
                            pageItem.item.option && pageItem.item.option[1]
                              ? pageItem.item.option[1].name
                              : ""
                          }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        pageItem.item &&
                        pageItem.item.type == 'likert' &&
                        infodata.send_type == 1
                      "
                    >
                      <div
                        class="mb-3"
                        v-for="(ites, ines) in pageItem.item.title"
                        :key="ines"
                      >
                        <div
                          class="mb-2"
                          v-if="
                            form[pageItem.sectionIndex] &&
                            form[pageItem.sectionIndex][pageItem.itemIndex] &&
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option &&
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option[ines]
                          "
                        >
                          <span
                            v-if="pageItem.item.is_required"
                            style="color: #ff797a"
                            >*</span
                          >
                          {{
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option[ines].index
                          }}.{{ ites.name }}
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center pl-3 pr-3 text-center"
                        >
                          <div class="sjbxzt" style="visibility: hidden">
                            {{ $t("參與前") }}
                          </div>
                          <div
                            class="sjbxzt"
                            v-for="(items, indexs) in pageItem.item.option"
                            :key="indexs"
                          >
                            {{ items.name }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center pl-3 pr-3 mt-3 text-center yuanjiao pt-3 pb-3"
                          style="background: #f6f4f0"
                        >
                          <div class="sjbxzt">{{ $t("參與前") }}</div>
                          <div
                            class="mr-3 curpo"
                            @click="
                              lktlb(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex,
                                ines,
                                1
                              )
                            "
                            v-for="(items, indexs) in pageItem.item.option"
                            :key="indexs"
                          >
                            <img
                              v-if="
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines] &&
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines].option &&
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines].option.pre == items.value
                              "
                              style="width: 20px; height: 20px"
                              src="@/img/icon_dl_xy_xz@2x (1).png"
                              alt=""
                            />
                            <img
                              v-else
                              style="width: 20px; height: 20px"
                              src="@/img/icon_dl_xy_wxz@2x (1).png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center pl-3 pr-3 mt-3 text-center yuanjiao pt-3 pb-3"
                          style="background: #f6f4f0"
                        >
                          <div class="sjbxzt">{{ $t("參與後") }}</div>
                          <div
                            class="mr-3 curpo"
                            @click="
                              lktlb(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex,
                                ines,
                                2
                              )
                            "
                            v-for="(items, indexs) in pageItem.item.option"
                            :key="indexs"
                          >
                            <img
                              v-if="
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines] &&
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines].option &&
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines].option.post == items.value
                              "
                              style="width: 20px; height: 20px"
                              src="@/img/icon_dl_xy_xz@2x (1).png"
                              alt=""
                            />
                            <img
                              v-else
                              style="width: 20px; height: 20px"
                              src="@/img/icon_dl_xy_wxz@2x (1).png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        pageItem.item &&
                        pageItem.item.type == 'likert' &&
                        infodata.send_type != 1
                      "
                    >
                      <div
                        class="mb-3"
                        v-for="(ites, ines) in pageItem.item.title"
                        :key="ines"
                      >
                        <div
                          class="mb-2"
                          v-if="
                            form[pageItem.sectionIndex] &&
                            form[pageItem.sectionIndex][pageItem.itemIndex] &&
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option &&
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option[ines]
                          "
                        >
                          <span
                            v-if="pageItem.item.is_required"
                            style="color: #ff797a"
                            >*</span
                          >
                          {{
                            form[pageItem.sectionIndex][pageItem.itemIndex]
                              .option[ines].index
                          }}.{{ ites.name }}
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center pl-3 pr-3 text-center"
                        >
                          <div
                            class="sjbxzt"
                            v-for="(items, indexs) in pageItem.item.option"
                            :key="indexs"
                          >
                            {{ items.name }}
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center pl-3 pr-3 mt-3 text-center yuanjiao pt-3 pb-3"
                          style="background: #f6f4f0"
                        >
                          <div
                            class="mr-3 curpo ml-4"
                            @click="
                              lktlb(
                                items.value,
                                pageItem.sectionIndex,
                                pageItem.itemIndex,
                                ines
                              )
                            "
                            v-for="(items, indexs) in pageItem.item.option"
                            :key="indexs"
                          >
                            <img
                              v-if="
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines] &&
                                form[pageItem.sectionIndex][pageItem.itemIndex]
                                  .option[ines].option === items.value
                              "
                              style="width: 20px; height: 20px"
                              src="@/img/icon_dl_xy_xz@2x (1).png"
                              alt=""
                            />
                            <img
                              v-else
                              style="width: 20px; height: 20px"
                              src="@/img/icon_dl_xy_wxz@2x (1).png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 導航按鈕 -->
          <div
            v-if="pages.length > 0"
            class="pl-0 pr-0 d-flex sjbdkd col-md-10 col-lg-9 mb-4"
            style="
              justify-content: space-between;
              margin: auto;
              position: static;
              bottom: auto;
            "
          >
            <!-- 上一頁按鈕 -->
            <div
              v-if="currentPage > 0"
              @click="prevPage()"
              class="yuanjiao text-center curpo pt-2 pb-2 tijwj sjbzt"
              :style="{
                width: currentPage === pages.length - 1 ? '48%' : '31%',
                marginRight: '2%',
              }"
            >
              {{ $t("上一頁") }}
            </div>

            <!-- 下一頁按鈕 -->
            <div
              v-if="currentPage < pages.length - 1"
              @click="nextPage()"
              class="yuanjiao text-center curpo pt-2 pb-2 tijwj sjbzt"
              :style="{
                width: currentPage === 0 ? '100%' : '31%',
                marginLeft: currentPage === 0 ? '0' : '2%',
              }"
            >
              {{ $t("下一頁") }}
            </div>

            <!-- 提交按鈕 -->
            <div
              v-if="currentPage === pages.length - 1"
              @click="tjwjsa()"
              class="yuanjiao text-center curpo pt-2 pb-2 tijwj sjbzt"
              style="width: 48%"
            >
              {{ $t("提交問卷") }}
            </div>
          </div>

          <b-modal
            v-model="modalShow"
            :backdrop="'static'"
            modal-class="custom-modal-width modal-mobile-fix"
            :centered="true"
            hide-header
            hide-footer
          >
            <div
              style="width: 100%; text-align: center"
              class="pb-2 position-relative"
            >
              <img
                @click="qrann1()"
                class="position-absolute curpo sbxfbd"
                style="width: calc(15px + 0.5vw); right: 20px; top: -20px"
                src="@/img/details/cha.png"
                alt=""
              />
              <div
                class="mb-3 mt-3 sjbzt"
                style="font-size: calc(12px + 0.4vw); font-weight: 700l"
              >
                {{ $t("提交成功") }}
              </div>
              <div
                class="p-3 yuanjiao"
                style="width: 90%; margin: auto; background: #f6f4f0"
              >
                <div class="sjbxzt" style="font-size: calc(8px + 0.4vw)">
                  <template v-if="infodata.template_type == 1">
                    {{ $t("您的問卷提交成功，感謝您的參與") }}
                  </template>
                  <template v-else>
                    <p
                      v-for="(paragraph, index) in (
                        infodata.template_info || ''
                      )
                        .split('\n')
                        .filter((p) => p.trim())"
                      :key="index"
                      class="mb-2"
                    >
                      {{ paragraph }}
                    </p>
                  </template>
                </div>
              </div>
              <div style="height: calc(10px + 1vw)"></div>
              <button
                @click="qrann1()"
                class="pl-3 pr-3 pt-2 pb-2 sjbzt yuanjiao ckqbb annys"
                style="font-size: calc(11px + 0.4vw)"
              >
                {{ $t("確認") }}
              </button>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  qrcode_questionnaire1,
  questionnaire_general_save,
} from "@/request/api.js";
import { timeFilter, formatTimestamp } from "@/utils/common.js";
export default {
  components: {},
  metaInfo() {
    // 創建完整的 meta 對象
    const metaInfo = {
      title: this.metaTitle,
      titleTemplate: null,
      htmlAttrs: {
        lang: "zh-TW",
      },
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          vmid: "description",
          name: "description",
          content: this.metaDescription,
        },
        // Open Graph / Facebook
        { vmid: "og:title", property: "og:title", content: this.metaTitle },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.metaDescription,
        },
        { vmid: "og:image", property: "og:image", content: this.metaImage },
        { vmid: "og:url", property: "og:url", content: window.location.href },
        { vmid: "og:type", property: "og:type", content: "website" },
        { vmid: "og:locale", property: "og:locale", content: "zh_TW" },
        // Twitter
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content: this.metaTitle,
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.metaDescription,
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: this.metaImage,
        },
        {
          vmid: "twitter:url",
          name: "twitter:url",
          content: window.location.href,
        },
        // 添加 Robots 指令，確保頁面可以被索引
        { vmid: "robots", name: "robots", content: "index, follow" },
      ],
      // 添加鏈接標籤
      link: [
        { vmid: "canonical", rel: "canonical", href: window.location.href },
      ],
      // 強制立即更新 meta 標籤
      changed() {
        if (this.$meta && typeof this.$meta === "function") {
          this.$meta().refresh();
        }
      },
    };

    // 如果有結構化數據，添加 JSON-LD 腳本
    if (this.structuredData) {
      metaInfo.script = [
        {
          vmid: "structured-data",
          type: "application/ld+json",
          json: this.structuredData,
        },
      ];
    }

    return metaInfo;
  },
  data() {
    return {
      modalShow: false,
      infodata: {},
      show: 0,
      form: [],
      list: [],
      currentPage: 0,
      pages: [],
      selScore: [
        {
          name: "1",
          value: 1,
        },
        {
          name: "2",
          value: 2,
        },
        {
          name: "3",
          value: 3,
        },
        {
          name: "4",
          value: 4,
        },
        {
          name: "5",
          value: 5,
        },
        {
          name: "6",
          value: 6,
        },
        {
          name: "7",
          value: 7,
        },
        {
          name: "8",
          value: 8,
        },
        {
          name: "9",
          value: 9,
        },
        {
          name: "10",
          value: 10,
        },
      ],
    };
  },
  computed: {
    metaTitle() {
      return this.infodata && this.infodata.name
        ? `好事道問卷-${this.infodata.name}`
        : "好事道問卷系統";
    },
    metaDescription() {
      // 確保描述存在且有適當的長度
      if (this.infodata && this.infodata.description) {
        // 擷取適當長度的描述 (推薦 150-160 字元)
        const desc = this.infodata.description.substring(0, 160);
        // 避免截斷詞句
        return desc.length < this.infodata.description.length
          ? desc.substring(0, desc.lastIndexOf("，") + 1) || desc
          : desc;
      }
      return "好事道問卷調查系統提供完整的問卷設計與填寫功能，協助您收集重要資訊和意見回饋。";
    },
    metaImage() {
      // 確保圖片 URL 有效
      if (
        this.infodata &&
        this.infodata.image &&
        this.infodata.image.startsWith("http")
      ) {
        return this.infodata.image;
      } else if (
        this.infodata &&
        this.infodata.organization_logo &&
        this.infodata.organization_logo.startsWith("http")
      ) {
        return this.infodata.organization_logo;
      }
      return "https://gddao.com/logo.png"; // 預設圖片
    },
    // 生成結構化數據以增強 SEO
    structuredData() {
      if (!this.infodata || !this.infodata.name) return null;

      return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: this.metaTitle,
        description: this.metaDescription,
        image: this.metaImage,
        url: window.location.href,
      };
    },
  },
  created() {
    this.formlist();

    document.title = this.metaTitle;
  },
  mounted() {
    // 確保在 DOM 渲染後更新 meta 標籤
    this.$nextTick(() => {
      if (this.$meta) {
        this.$meta().refresh();
      }

      // 針對移動設備添加輸入框事件處理
      this.setupInputHandlers();
    });

    // 監聽視窗大小變化
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    // 清理事件監聽器
    window.removeEventListener("resize", this.handleResize);
    this.cleanupInputHandlers();
  },
  updated() {
    // 在組件更新後刷新 meta 數據
    this.$nextTick(() => {
      if (this.$meta) {
        this.$meta().refresh();
      }
    });
  },
  watch: {
    infodata: {
      handler(newVal) {
        if (newVal && newVal.name) {
          document.title = this.metaTitle;
          // 當問卷數據變化時，強制刷新 meta 標籤
          this.$nextTick(() => {
            if (this.$meta) {
              this.$meta().refresh();
            }
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    // 處理圖片 URL，確保其安全有效
    processImageUrl(url) {
      if (!url) return "https://gddao.com/logo.png";

      try {
        // 檢查 URL 是否有效
        new URL(url);
        return url;
      } catch (error) {
        console.warn("無效的圖片 URL:", url);
        return "https://gddao.com/logo.png";
      }
    },
    huidasdxsa(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    qrann1() {
      this.$router.push("/");
    },
    chaanhdxiangq() {
      this.$router.push(
        "/activity/" +
          this.$route.params.leix +
          "/" +
          this.$route.params.slug +
          "/" +
          this.infodata.activity_id +
          "/info"
      );
    },
    async tjwjsa() {
      console.log("提交表單數據:", this.form);

      // 收集所有問卷項目的答案
      let answers = [];
      // 驗證邏輯
      for (let pageIndex = 0; pageIndex < this.pages.length; pageIndex++) {
        for (
          let itemIndex = 0;
          itemIndex < this.pages[pageIndex].length;
          itemIndex++
        ) {
          const pageItem = this.pages[pageIndex][itemIndex];
          const sectionIndex = pageItem.sectionIndex;
          const questionIndex = pageItem.itemIndex;

          // 跳過 header 類型的項目，因為它們是分段標題，不需要填寫
          if (pageItem.item && pageItem.item.type === "header") {
            continue;
          }

          if (pageItem.item && pageItem.item.is_required) {
            if (
              !this.form[sectionIndex] ||
              !this.form[sectionIndex][questionIndex]
            ) {
              console.warn("找不到對應表單數據:", sectionIndex, questionIndex);
              continue;
            }
            const formItem = this.form[sectionIndex][questionIndex];
            let isEmpty = false;
            if (pageItem.item.type === "likert") {
              if (this.infodata.send_type == 1) {
                if (
                  !formItem.option ||
                  formItem.option.some(
                    (subItem) => !subItem.option.pre || !subItem.option.post
                  )
                ) {
                  isEmpty = true;
                }
              } else {
                if (
                  !formItem.option ||
                  formItem.option.some((subItem) => !subItem.option)
                ) {
                  isEmpty = true;
                }
              }
            } else if (pageItem.item.type === "checkbox") {
              if (!formItem.option || formItem.option.length === 0) {
                isEmpty = true;
              }
            } else {
              if (
                formItem.option === "" ||
                formItem.option === null ||
                formItem.option === undefined
              ) {
                isEmpty = true;
              }
            }

            if (isEmpty) {
              let questionTitle = pageItem.item.title;
              if (
                pageItem.item.type === "likert" &&
                Array.isArray(pageItem.item.title) &&
                pageItem.item.title.length > 0
              ) {
                // For likert, it might be an array of titles or a single title string.
                // This uses the first title as a generic reference if it's an array.
                questionTitle =
                  pageItem.item.title[0].name || pageItem.item.title[0];
              }
              this.$bvToast.toast(
                `請回答問題: ${questionTitle || "第" + formItem.index + "題"}`,
                {
                  title: this.$t("login.warning"),
                  variant: "danger",
                  solid: true,
                  autoHideDelay: 3000,
                }
              );
              return; // 停止提交
            }
          }
        }
      }

      // 遍歷所有頁面和項目
      for (let pageIndex = 0; pageIndex < this.pages.length; pageIndex++) {
        for (
          let itemIndex = 0;
          itemIndex < this.pages[pageIndex].length;
          itemIndex++
        ) {
          const pageItem = this.pages[pageIndex][itemIndex];
          const sectionIndex = pageItem.sectionIndex;
          const questionIndex = pageItem.itemIndex;

          // 跳過 header 類型
          if (pageItem.item && pageItem.item.type === "header") {
            continue;
          }

          // 獲取表單數據
          if (
            !this.form[sectionIndex] ||
            !this.form[sectionIndex][questionIndex]
          ) {
            console.warn("找不到對應表單數據:", sectionIndex, questionIndex);
            continue;
          }

          const formItem = this.form[sectionIndex][questionIndex];

          // 根據問卷項目類型處理答案
          if (pageItem.item.type === "likert") {
            // likert量表需要特殊處理
            let likertAnswers = {};
            if (formItem.option && Array.isArray(formItem.option)) {
              for (let i = 0; i < formItem.option.length; i++) {
                if (this.infodata.send_type == 1) {
                  // 合併發放格式
                  likertAnswers[formItem.option[i].id] =
                    formItem.option[i].option;
                } else {
                  // 分別發放格式
                  likertAnswers[formItem.option[i].id] =
                    formItem.option[i].option;
                }
              }
            }

            answers.push({
              id: pageItem.item.id,
              answer: likertAnswers,
            });
          } else if (pageItem.item.type === "checkbox") {
            // 複選框傳遞數組
            answers.push({
              id: pageItem.item.id,
              answer: formItem.option || [],
            });
          } else {
            // 其他類型（單選、文本等）
            answers.push({
              id: pageItem.item.id,
              answer: formItem.option,
            });
          }
        }
      }

      // 顯示提交中的確認
      this.modalShow = true;

      try {
        console.log("正在提交問卷答案:", answers);

        // 使用一般問卷提交API
        const result = await questionnaire_general_save({
          number: this.$route.params.id,
          answer: answers,
        });

        console.log("問卷提交結果:", result);

        if (result.code === 200) {
          // 顯示成功提示（保持彈窗顯示）
          this.$root.$bvToast.toast("問卷提交成功，感謝您的參與！", {
            title: "提交成功",
            variant: "success",
            solid: true,
            autoHideDelay: 5000,
          });

          // 延遲5秒後自動返回首頁，讓用戶有更多時間查看成功訊息
          // 用戶也可以手動點擊關閉按鈕或確認按鈕
          setTimeout(() => {
            if (this.modalShow) {
              // 只有在模態視窗仍顯示時才跳轉
              this.$router.push("/");
            }
          }, 7000);
        } else {
          // 關閉模態視窗
          this.modalShow = false;

          // 顯示錯誤提示
          this.$bvToast.toast(result.msg || "提交問卷時出錯，請稍後再試", {
            title: "錯誤",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          });
        }
      } catch (error) {
        // 關閉模態視窗
        this.modalShow = false;

        console.error("提交問卷時發生錯誤:", error);
        this.$bvToast.toast("提交問卷時出錯，請稍後再試", {
          title: "錯誤",
          variant: "danger",
          solid: true,
          autoHideDelay: 5000,
        });
      }
    },
    danxuan(e, m, v) {
      this.$set(this.form[m][v], "option", e);
    },
    duoxuan(e, m, v) {
      const index = this.form[m][v].option.indexOf(e);
      if (this.form[m][v].option.includes(e)) {
        this.form[m][v].option.splice(index, 1);
      } else {
        this.form[m][v].option.push(e);
      }
    },
    lktlb(e, m, v, s, f) {
      if (this.infodata.send_type == 1) {
        if (f == 1) {
          this.form[m][v].option[s].option.pre = e;
        } else {
          this.form[m][v].option[s].option.post = e;
        }
      } else {
        this.form[m][v].option[s].option = e;
      }
    },
    async formlist() {
      try {
        console.log("問卷編號:", this.$route.params.id);

        const { data, msg, code } = await qrcode_questionnaire1({
          number: this.$route.params.id,
        });

        console.log("API響應:", { code, msg, data });

        if (code == 200) {
          // 檢查數據結構
          if (!data || !data.data) {
            console.error("API響應缺少數據結構");
            this.$bvToast.toast("載入問卷失敗：API響應格式錯誤", {
              title: "錯誤",
              variant: "danger",
              solid: true,
            });
            return;
          }

          // 防護性處理：確保關鍵屬性正確初始化
          const processedData = {
            ...data.data,
            image: this.processImageUrl(data.data.image),
            organization_logo: this.processImageUrl(
              data.data.organization_logo
            ),
          };

          if (!processedData.item || !Array.isArray(processedData.item)) {
            console.error("API響應缺少問卷項目陣列");
            this.$bvToast.toast("載入問卷失敗：問卷項目格式錯誤", {
              title: "錯誤",
              variant: "danger",
              solid: true,
            });
            return;
          }

          console.log("問卷內容:", JSON.stringify(processedData.item));

          // 存儲處理過的問卷數據
          this.list = processedData.item || [];
          this.infodata = processedData || {};

          // 確保 send_type 存在，預設為 1 (即使API未返回此值)
          if (!this.infodata.send_type) {
            console.log("設置默認的 send_type = 1");
            this.infodata.send_type = 1;
          }

          // 確保 type 存在，預設為 1 (用於問卷提交)
          if (!this.infodata.type) {
            console.log("設置默認的 type = 1");
            this.infodata.type = 1;
          }

          // 將問卷拆分為多個頁面
          this.createPages();

          // 處理表單數據
          this.createFormData();

          // 檢查問卷是否為空
          if (this.pages.length === 0) {
            console.error("問卷頁面為空");
            this.$bvToast.toast("問卷內容為空", {
              title: "錯誤",
              variant: "danger",
              solid: true,
            });
          } else {
            console.log(`問卷共有 ${this.pages.length} 頁`);
          }
        } else {
          // 處理 API 錯誤
          console.error(`API錯誤: ${code} - ${msg}`);
          this.$bvToast.toast(msg || "載入問卷失敗", {
            title: "錯誤",
            variant: "danger",
            solid: true,
          });
        }
      } catch (error) {
        // 處理異常
        console.error("載入問卷時出錯:", error);
        this.$bvToast.toast("載入問卷時出錯，請稍後再試", {
          title: "錯誤",
          variant: "danger",
          solid: true,
        });
      }
    },

    // 創建問卷頁面
    createPages() {
      this.pages = [];

      if (!this.list || !Array.isArray(this.list) || this.list.length === 0) {
        console.warn("創建頁面失敗：問卷列表為空或格式錯誤");
        return;
      }

      try {
        // 初始化頁面
        let currentPage = [];

        // 遍歷所有問卷部分
        for (
          let sectionIndex = 0;
          sectionIndex < this.list.length;
          sectionIndex++
        ) {
          const section = this.list[sectionIndex];

          if (!section || !section.item || !Array.isArray(section.item)) {
            console.warn(
              `第 ${sectionIndex + 1} 部分問卷項目為空或格式錯誤，跳過此部分`
            );
            continue;
          }

          // 遍歷每個部分的所有項目
          for (
            let itemIndex = 0;
            itemIndex < section.item.length;
            itemIndex++
          ) {
            const item = section.item[itemIndex];

            // 嚴格檢查項目是否有效
            if (!item || typeof item !== "object" || !item.type) {
              console.warn(
                `第 ${sectionIndex + 1} 部分第 ${
                  itemIndex + 1
                } 項無效或缺少類型屬性，跳過此項目`
              );
              continue;
            }

            // 如果是header類型且設置了新頁面標記，則創建新頁面
            // 但第一個項目永遠放在第一頁，不管isNewPage設置
            if (
              item.type === "header" &&
              item.isNewPage &&
              currentPage.length > 0
            ) {
              // 保存當前頁面並創建新頁面
              this.pages.push([...currentPage]);
              currentPage = [];
            }

            // 將項目添加到當前頁面
            // 創建帶有部分信息的項目對象
            currentPage.push({
              sectionIndex: sectionIndex, // 原始部分索引
              itemIndex: itemIndex, // 原始項目索引
              section: section, // 部分信息
              item: item, // 項目信息
            });
          }
        }

        // 添加最後一頁
        if (currentPage.length > 0) {
          this.pages.push([...currentPage]);
        }

        console.log(`已創建 ${this.pages.length} 個問卷頁面`);
        this.currentPage = 0;
      } catch (error) {
        console.error("創建問卷頁面時出錯:", error);
        this.pages = []; // 確保在出錯時也有一個有效的空頁面數組
      }
    },

    // 創建表單數據
    createFormData() {
      let forlist = [];
      let a = 0;

      try {
        if (!this.list || !Array.isArray(this.list) || this.list.length === 0) {
          console.warn("問卷列表為空或格式錯誤");
          this.form = [];
          return;
        }

        for (let i = 0; i < this.list.length; i++) {
          // 創建每個部分的表單數組
          forlist.push([]);

          // 嚴格檢查 item[i].item 是否存在且為數組
          if (
            !this.list[i] ||
            !this.list[i].item ||
            !Array.isArray(this.list[i].item)
          ) {
            console.warn(`第 ${i + 1} 部分問卷項目為空或格式錯誤，跳過此部分`);
            continue;
          }

          for (let j = 0; j < this.list[i].item.length; j++) {
            const currentItem = this.list[i].item[j];

            // 嚴格檢查 item 是否有有效類型
            if (!currentItem || !currentItem.type) {
              console.warn(
                `第 ${i + 1} 部分第 ${j + 1} 項缺少類型屬性，跳過此項目`
              );
              continue;
            }

            try {
              if (currentItem.type === "header") {
                // 為 header 類型創建特殊的表單項
                forlist[i].push({
                  id: currentItem.id || 0,
                  type: "header",
                  title: currentItem.title || "",
                  description: currentItem.description || "",
                  isNewPage: currentItem.isNewPage || false,
                  option: null,
                });
              } else if (currentItem.type === "checkbox") {
                a = a + 1;
                forlist[i].push({
                  id: currentItem.id || 0,
                  type: "checkbox",
                  option: [],
                  index: a,
                });
              } else if (currentItem.type === "likert") {
                if (this.infodata.send_type === 1) {
                  let suxja = [];

                  // 檢查 title 是否存在且為陣列
                  if (!currentItem.title || !Array.isArray(currentItem.title)) {
                    console.warn(
                      `李克特量表題目不存在或格式錯誤: ${JSON.stringify(
                        currentItem
                      )}`
                    );
                    continue;
                  }

                  for (let s = 0; s < currentItem.title.length; s++) {
                    a = a + 1;
                    suxja.push({
                      id: currentItem.title[s].id || 0,
                      option: { pre: "", post: "" },
                      index: a,
                    });
                  }

                  forlist[i].push({
                    id: currentItem.id || 0,
                    type: "likert",
                    option: suxja,
                  });
                } else {
                  console.log("處理非合併發放的李克特量表");
                  let suxja = [];

                  if (!currentItem.title || !Array.isArray(currentItem.title)) {
                    console.warn(
                      `李克特量表題目不存在或格式錯誤: ${JSON.stringify(
                        currentItem
                      )}`
                    );
                    continue;
                  }

                  for (let s = 0; s < currentItem.title.length; s++) {
                    a = a + 1;
                    suxja.push({
                      id: currentItem.title[s].id || 0,
                      option: "",
                      index: a,
                    });
                  }

                  forlist[i].push({
                    id: currentItem.id || 0,
                    type: "likert",
                    option: suxja,
                  });
                }
              } else {
                // 其他類型的問題 (radio, input, textarea, score, scale)
                a = a + 1;
                forlist[i].push({
                  id: currentItem.id || 0,
                  type: currentItem.type, // 保存類型，方便後續判斷
                  option: "",
                  index: a,
                });
              }
            } catch (itemError) {
              console.error(
                `處理第 ${i + 1} 部分第 ${j + 1} 項時出錯:`,
                itemError
              );
              // 繼續處理下一項
            }
          }
        }

        this.form = forlist;
        console.log("表單結構:", this.form);
      } catch (error) {
        console.error("創建表單結構時出錯:", error);
        // 確保有一個有效的空表單結構
        this.form = [[]];
      }
    },

    // 導航到下一頁
    nextPage() {
      if (this.currentPage < this.pages.length - 1) {
        this.currentPage++;
        // 加強版滾動到頂部，適用於各種設備
        this.$nextTick(() => {
          // 多種滾動方法結合，確保在不同設備都有效
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;

          // 延遲0毫秒確保瀏覽器有時間響應
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "auto" });
            const scrollableElement = document.querySelector(".sjbdyuanjiao");
            if (scrollableElement) {
              scrollableElement.scrollTop = 0;
            }
          }, 0);
        });
      }
    },

    // 導航到上一頁
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        // 加強版滾動到頂部，適用於各種設備
        this.$nextTick(() => {
          // 多種滾動方法結合，確保在不同設備都有效
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;

          // 延遲0毫秒確保瀏覽器有時間響應
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "auto" });
            const scrollableElement = document.querySelector(".sjbdyuanjiao");
            if (scrollableElement) {
              scrollableElement.scrollTop = 0;
            }
          }, 0);
        });
      }
    },

    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch (_) {
        return false;
      }
    },

    handleImageError(event) {
      event.target.src = "https://gddao.com/logo.png";
    },

    setupInputHandlers() {
      // 獲取所有輸入元素
      const inputs = document.querySelectorAll("input, textarea");

      // 為每個輸入元素添加事件處理
      inputs.forEach((input) => {
        input.addEventListener("focus", this.handleInputFocus);
        input.addEventListener("blur", this.handleInputBlur);
      });
    },

    cleanupInputHandlers() {
      // 移除所有輸入元素的事件處理
      const inputs = document.querySelectorAll("input, textarea");
      inputs.forEach((input) => {
        input.removeEventListener("focus", this.handleInputFocus);
        input.removeEventListener("blur", this.handleInputBlur);
      });
    },

    handleInputFocus(event) {
      // 輸入框獲得焦點時
      document.body.classList.add("input-focused");

      // 在移動設備上，確保元素在視野中
      if (window.innerWidth <= 768) {
        // 延遲執行滾動操作，等待鍵盤彈出完成
        setTimeout(() => {
          // 計算元素位置並滾動
          const rect = event.target.getBoundingClientRect();
          const scrollPosition = rect.top + window.scrollY - 120; // 確保輸入框在視野中上方有足夠空間
          window.scrollTo({
            top: scrollPosition,
            behavior: "smooth",
          });
        }, 300);
      }
    },

    handleInputBlur() {
      // 輸入框失去焦點時
      document.body.classList.remove("input-focused");

      // 修復可能的滾動問題
      setTimeout(() => {
        window.scrollTo(0, window.scrollY);
      }, 100);
    },

    handleResize() {
      // 處理視窗大小變化
      const viewportHeight = window.innerHeight;
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${viewportHeight}px`
      );
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 792px) {
  .mox {
    padding-top: 0px !important;
    height: 100vh !important;
    width: 100% !important;
    overflow: hidden !important;
  }
  .sjbdyuanjiao {
    border-radius: 0px;
    height: 100vh !important;
    max-height: 100vh !important;
    margin: 0 !important;
  }
}
.mox {
  width: 100%;
  min-height: 100vh;
  height: auto;
  background: #f6f4f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 0;
}
@media screen and (max-width: 992px) {
  .yinc {
    display: none !important;
  }

  .sjbdtp {
    width: 100% !important;
  }

  .sjbyj {
    margin-top: 1rem;
  }

  .sjbdkds {
    width: 75% !important;
  }

  .sjdasxwd {
    width: 70% !important;
  }

  .sjbdmr {
    margin-right: 1rem !important;
  }

  .sjbdkd {
    width: 100% !important;
  }

  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }

  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }

  .aaaaa {
    display: block !important;
  }

  .heggs {
    height: 93vh !important;
  }
}

.aaaaa {
  display: none;
}

.anbutton {
  background: #ffd672;
  font-size: 13px;
}

.srkddx {
  background: #f6f4f0;
  border: none;
  border-radius: 12px;
  width: 100%;
}

.tijwj {
  margin: auto;
  background: #ffd672;
  font-size: calc(8px + 0.5vw);
  border: none;
  outline: none;
  transition: all 0.3s ease;
}

.tijwj:active,
.tijwj:focus {
  transform: scale(0.98);
}

.yzm {
  height: 27px;
  line-height: 27px;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #1a1a1a;
  background: #ffd672;
  border-radius: 12px;
  padding: 0 12px;
}

.srkzt {
  font-size: 13px;
}

.srkxzt {
  font-size: 11px;
}

.yhxyi {
  font-size: calc(10px);

  span {
    color: #b66d00;
  }
}

.xian {
  width: 30%;
  height: 2px;
  background: #ffd672;
  margin: auto;
}

.ckhdxq {
  background: #ffeab8;
  font-size: 13px;
  width: 55%;
  margin: auto;
}

.ztnjj {
  font-size: 14px;
  font-weight: 600;
}

.content {
  font-size: calc(10px + 0.4vw);
  line-height: calc(20px + 0.5vw);
}

.pjfs {
  border-radius: 6px;
  padding: 6px 10px 6px 10px;
}

.heggt {
  height: 76vh;
  overflow-y: auto;
  width: 100%;
}

.swkd {
  font-size: 15px;
  font-weight: 700;
}

/* 問卷內容相關樣式 */
.question-container {
  padding-bottom: 60px; /* 確保最後一個問題與底部有足夠空間 */
}

/* 修復底部顯示問題 */
body {
  min-height: 100vh;
  background-color: #f6f4f0;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

/* 確保滾動容器填滿整個視口 */
.lieb {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
  overflow-y: auto;
  height: 100%;
  width: 100%;
  background: white;
}

/* 隱藏滾動條但保留功能 */
.lieb::-webkit-scrollbar {
  display: none;
}

@media screen and (max-width: 480px) {
  .sjbxzt {
    font-size: calc(12px + 0.3vw) !important;
  }

  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }

  /* 選項框樣式優化 */
  .curpo {
    padding: 12px 10px !important;
  }
}

.sysr {
  font-size: 12px;
  color: #b66d00;
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.srkleft {
  width: calc(17px + 0.4vw);
  margin-left: calc(8px + 0.4vw);
}
.annys {
  font-size: calc(6px + 0.4vw);
  background: #ffd672;
  width: 144px;
  margin: auto;
  border: none;
}
.section-divider {
  margin: 15px 0;
  display: flex;
  align-items: center;
}
.divider-line {
  flex-grow: 1;
  height: 1px;
  background-color: #dcdfe6;
}
.divider-text {
  padding: 0 10px;
  color: #409eff;
  font-weight: bold;
  font-size: 14px;
}
.section-header-title {
  margin-top: 10px;
  padding-bottom: 5px;
  border-bottom: 2px solid #ffd672;
  color: #333;
  display: inline-block;
  font-size: calc(12px + 0.4vw);
  font-weight: bold;
}
.section-description {
  color: #666;
  font-size: calc(12px + 0.4vw);
  line-height: 1.5;
}
.rigmima {
  width: calc(17px + 0.4vw);
  right: 10px;
}
.denglu {
  background: #ffd672;
  border-radius: 13px !important;
  border: none;
  color: #1a1a1a;
  font-size: calc(7px + 0.4vw);
}

textarea.form-control {
  overflow-y: auto !important;
}

.sjyz {
  width: 48%;
  height: 36px;
  line-height: 30px;
  border-radius: 12px;
  text-align: center;
  font-weight: 400;
  font-size: calc(7px + 0.5vw);
  color: #1a1a1a;
  border: none;
}

.dzyxyz {
  width: 48%;
  height: 36px;
  line-height: 30px;
  border-radius: 12px;
  text-align: center;
  font-weight: 400;
  font-size: calc(7px + 0.5vw);
  color: #1a1a1a;
  border: none;
}

.scys {
  background: #f6f4f0;
  border: none;
  border-radius: 12px;
  height: calc(35px + 0.4vw);
}

.questionnaire-description p {
  margin-bottom: 10px;
  line-height: 1.5;
}

/* 自定義模態框在移動設備上的樣式 */
.modal-mobile-fix {
  max-width: 95% !important;
  margin: 0 auto;
}

@media screen and (max-width: 576px) {
  .modal-mobile-fix {
    max-width: 98% !important;
  }

  .annys {
    width: auto !important;
    font-size: calc(10px + 0.4vw) !important;
    padding: 8px 20px !important;
  }

  .custom-modal-width {
    width: 95% !important;
  }
}

/* 防止iOS上的縮放問題 */
input[type="text"],
input[type="email"],
input[type="tel"],
input[type="number"],
textarea {
  font-size: 16px !important; /* 確保iOS不會自動縮放 */
  -webkit-appearance: none; /* 移除默認樣式 */
  -moz-appearance: none;
  appearance: none;
  border-radius: 12px;
}

/* 使用CSS變量設置視窗高度 */
:root {
  --viewport-height: 100vh;
}

/* 專為輸入狀態設計的樣式 */
body.input-focused .mox {
  height: auto !important;
  min-height: var(--viewport-height) !important;
}

body.input-focused .sjbdyuanjiao {
  height: auto !important;
  max-height: none !important;
  min-height: var(--viewport-height) !important;
}

/* 修復虛擬鍵盤彈出時的布局 */
@media screen and (max-width: 768px) {
  .mox {
    position: relative;
    min-height: var(--viewport-height) !important;
  }

  .sjbdyuanjiao {
    min-height: calc(var(--viewport-height) - 20px) !important;
    height: auto !important;
    margin-bottom: 0 !important;
  }

  /* 確保表單底部有足夠空間 */
  .question-container {
    padding-bottom: 120px !important; /* 為虛擬鍵盤留出空間 */
  }

  /* 保持標題在頂部 */
  #jnkwsedf {
    position: sticky !important;
    top: 0 !important;
    z-index: 101 !important;
  }

  /* 確保底部按鈕永遠可見 */
  .pl-0.pr-0.d-flex.sjbdkd.col-md-10.col-lg-9.mb-4 {
    position: static !important;
    bottom: auto !important;
    z-index: auto !important;
    background: transparent !important;
    padding: 10px !important;
    border-radius: 12px !important;
    box-shadow: none !important;
  }
}
</style>
